const comments = [
  {
    id: 1,
    name: '吃瓜不嫌事大',
    avatar: 'https://readdy.ai/api/search-image?query=Stylish%20abstract%20geometric%20avatar%20in%20warm%20red%20coral%20tones%20with%20gradient%20circle%20design%2C%20minimal%20flat%20vector%20style%2C%20clean%20background%2C%20modern%20social%20media%20profile%20picture%20aesthetic&width=80&height=80&seq=avatar-comment-1&orientation=squarish',
    time: '3分钟前',
    content: '刚从微博过来，这边爆料速度确实快！那个顶流塌房的消息全网就你们首发，吃瓜吃到自己家了属于是。',
    likes: 1283,
  },
  {
    id: 2,
    name: '深夜吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Modern%20abstract%20avatar%20in%20amber%20gold%20tones%20with%20clean%20geometric%20shapes%2C%20minimalist%20flat%20design%2C%20warm%20gradient%20background%2C%20social%20profile%20style%20illustration&width=80&height=80&seq=avatar-comment-2&orientation=squarish',
    time: '18分钟前',
    content: '这个点还在蹲更新的应该不止我一个吧？每天的快乐源泉就是来这里刷最新爆料，比刷剧还上头！',
    likes: 867,
  },
  {
    id: 3,
    name: '理性吃瓜群众',
    avatar: 'https://readdy.ai/api/search-image?query=Elegant%20minimal%20avatar%20design%20in%20warm%20neutral%20gray%20tones%20with%20simple%20circle%20composition%2C%20clean%20flat%20vector%20illustration%2C%20modern%20social%20media%20profile%20style%2C%20subtle%20gradient&width=80&height=80&seq=avatar-comment-3&orientation=squarish',
    time: '42分钟前',
    content: '作为一个老粉，91黑料的内容质量一直在线。爆料有图有真相，不像某些营销号只会编故事。推荐给了身边所有爱吃瓜的朋友。',
    likes: 2156,
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          吃瓜群众<i className="ri-chat-smile-2-line text-primary-500 ml-2"></i>
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">大家都在说什么</p>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-5">
          {comments.map((c) => (
            <article key={c.id} className="bg-background-50 rounded-xl p-5 border border-background-200/70">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img src={c.avatar} alt={c.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-foreground-900 truncate">{c.name}</div>
                  <div className="text-xs text-foreground-500">{c.time}</div>
                </div>
              </div>
              <p className="mt-3 text-sm text-foreground-700 leading-relaxed">{c.content}</p>
              <div className="mt-3 flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-heart-line text-primary-500"></i>
                <span>{c.likes.toLocaleString()}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}